// extracted by mini-css-extract-plugin
export var borderRadius = "_5j-4";
export var large = "_5j-3";
export var logoContainer = "_5j-0";
export var nameLogo = "_5j-2";
export var small = "_5j-1";